import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';
import CloseBtn from 'components/util/CloseModal';
import { useModal } from '../../hooks/modalContext';

import * as Server from 'assets/js/Server';
import * as Common from '../../assets/js/Common';

const DiscountModal = props => {
  const { closeModal } = useModal();

  // props 구조 분해 할당으로 경로 단순화
  const modalProps = props.props;
  const isRegi = modalProps?.isRegi;
  const originItem = modalProps?.data?.item;
  const parentCallback = modalProps?.data?.callback;

  const [param, setParam] = useState({
    shopifyDiscountCodeMstSeq: 0,
    discountCode: '',
    incentive: '',
  });

  const [isIdCheck, setIsIdCheck] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    if (originItem && !Common.isEmpty(originItem)) {
      setParam({
        shopifyDiscountCodeMstSeq: originItem.shopifyDiscountCodeMstSeq || 0,
        discountCode: originItem.discountCode || '',
        incentive: originItem.incentive || '',
      });

      if (!isRegi && originItem.discountCode) {
        setIsIdCheck(true);
      }
    }
  }, [originItem, isRegi]);

  const checkDiscountCode = () => {
    if (Common.isEmpty(param.discountCode)) {
      Common.errorMsg('Please enter a Discount Code.');
      return;
    }

    Server.sendGet('shopify/sales/discount/check', {
      discountCode: param.discountCode
    }, (res) => {
      const result = res?.['resultCount'];
      if (result > 0) {
        Common.errorMsg('This Discount Code is already in use.');
        setIsIdCheck(false);
      } else {
        Common.errorMsg('This code is available.');
        setIsIdCheck(true);
      }
    }).then();
  };

  const handleSubmit = () => {
    if (Common.isEmpty(param.discountCode)) {
      Common.errorMsg('Discount Code is required.');
      return;
    }
    if (!isIdCheck) {
      Common.errorMsg('Please verify the Discount Code (Duplicate Check).');
      return;
    }
    if (Common.isEmpty(param.incentive)) {
      Common.errorMsg('Incentive Percent is required.');
      return;
    }

    if (isSubmit) return;

    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to ${isRegi ? 'register' : 'modify'} this item?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const sendData = {
              ...param,
              shopifyDiscountCodeMstSeq: Number(param.shopifyDiscountCodeMstSeq || 0)
            };

            // 서버 응답이 200인데 안 닫힌다면 콜백 함수가 실행되는지 확인이 필요함
            Server.sendPost('shopify/sales/discount/info', sendData, (res) => {
              // 응답 직후 상태 초기화
              setIsSubmit(false);

              // 1. 성공 메시지 (Common.alertSuccess가 내부적으로 오류가 없는지 확인 필요)
              Common.alertSuccess();

              // 2. 부모 콜백 실행 (직접 참조)
              if (typeof parentCallback === 'function') {
                parentCallback();
              }

              // 3. 팝업 닫기 (강제 실행)
              closeModal();

            }).then(() => {
              // then에서도 성공 처리 보강 (네트워크 200 시 확실히 처리하기 위함)
              if (isSubmit) setIsSubmit(false);
            }).catch(() => {
              setIsSubmit(false);
            });
          }
        },
        { label: 'No' }
      ]
    });
  };

  const isCheckBtnDisabled =
    Common.isEmpty(param.discountCode) ||
    isIdCheck ||
    (!isRegi && param.discountCode === originItem?.discountCode);

  return (
    <>
      <CloseBtn onClick={closeModal}/>

      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Discount Code {isRegi ? 'Registration' : 'Modify'}</h4>
          </TitHead>
        </Title>
        <ModalForm>
          <FormIn>
            <FormInWrap>
              <label><span>* </span>Discount Code</label>
              <FormInput
                style={{ width: 'calc(70% - 10px)' }}
                type='text'
                placeholder="Enter Discount Code"
                value={param?.discountCode || ''}
                onChange={e => {
                  setParam({ ...param, discountCode: e.target.value });
                  setIsIdCheck(false);
                }}
              />
              <Btn
                type="button"
                style={{
                  flex: 'none',
                  width: '15%',
                  fontSize: '16px',
                  background: isCheckBtnDisabled ? '#a4a4a4' : '#0072b9',
                  cursor: isCheckBtnDisabled ? 'default' : 'pointer'
                }}
                disabled={isCheckBtnDisabled}
                onClick={checkDiscountCode}
              >
                {isIdCheck ? 'Checked' : 'Check'}
              </Btn>
            </FormInWrap>
          </FormIn>
          <FormIn>
            <FormInWrap>
              <label><span>* </span>Incentive Percent</label>
              <FormInput
                style={{ width: 'calc(91% - 10px)' }}
                type='number'
                placeholder="Enter Incentive Percent"
                value={param?.incentive || ''}
                onChange={e => setParam({ ...param, incentive: e.target.value })}
              />
            </FormInWrap>
          </FormIn>

          <FormBtn>
            <Btn onClick={closeModal}>Cancel</Btn>
            <Btn $Color onClick={handleSubmit}>Submit</Btn>
          </FormBtn>
        </ModalForm>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  padding: 40px;
  width: 700px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
    margin: 0;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 100%;
  align-items: center;
  gap: 0 10px;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
      color: red;
    }
  }
`;

const FormInput = styled.input`
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props.$Color ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${props => (props.$Color ? '#075C97' : '#7e7e7e')};
  }
`;

export default DiscountModal;
